module.exports = __webpack_public_path__ + "img/service_report.34d4e332.png";